import { useEffect, useReducer } from 'react';

import { logger } from '#src/lib/logger';
import { useDeepLinkApi } from '#src/hooks';

export function useDeepLinker(attrs) {
  const api = useDeepLinkApi();
  const [{ deepLinkUrl, error, handleClick, loading }, setState] = useReducer(
    (s, a) => ({ ...s, ...a }),
    {
      deepLinkUrl: null,
      error: null,
      handleClick: null,
      loading: false,
    }
  );

  useEffect(() => {
    if (!api || !attrs || deepLinkUrl || error || handleClick || loading) {
      return;
    }

    setState({ loading: true });

    (async () => {
      try {
        const link = await api.createLink(attrs);
        if (api.isDesktop) {
          setState({ deepLinkUrl: link });
        } else {
          api.prepareHandleDeepLinkClick(attrs);
          setState({ handleClick: api.handleDeepLinkClick });
        }
      } catch (e) {
        logger.error(`[useDeepLinker] ${e.message}`, { e });
        setState({ error: e });
      }
      setState({ loading: false });
    })();
  }, [api, attrs, deepLinkUrl, error, handleClick, loading]);

  return {
    deepLinkUrl,
    error,
    handleClick,
    loading,
  };
}
